import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import airports from "../../Data/AirportList.json";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  RiCalendarLine,
  RiFlightTakeoffLine,
  RiFlightLandLine,
} from "react-icons/ri";

const SearchFlightPanel = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [departureDate, setDepartureDate] = useState(new Date());
  const [returnDate, setReturnDate] = useState(new Date());
  const [departureResults, setDepartureResults] = useState([]);
  const [arrivalResults, setArrivalResults] = useState([]);
  const [locationFrom, setLocationFrom] = useState("HYD");
  const [locationTo, setLocationTo] = useState("BOM");
  const [displayFrom, setDisplayFrom] = useState("Hyderabad(HYD), India");
  const [displayTo, setDisplayTo] = useState("Mumbai(BOM), India");
  const [selectedDeparture, setSelectedDeparture] = useState(null);
  const [selectedArrival, setSelectedArrival] = useState(null);
  const [cityFrom, setCityFrom] = useState("Hyderabad");
  const [cityTo, setCityTo] = useState("Mumbai");
  const [from, setFrom] = useState("Hyderabad, India");
  const [to, setTo] = useState("Mumbai, India");
  const [trips, setTrips] = useState([
    {
      from: "HYD, India",
      to: "BOM, India",
      locationFrom: "HYD",
      locationTo: "BOM",
      displayFrom: "Hyderabad(HYD)",
      displayTo: "Mumbai(BOM)",
      cityFrom: "Hyderabad",
      cityTo: "Mumbai",
      departureDate: new Date(),
      departureResults: [],
      arrivalResults: [],
    },
  ]);
  const [adults, setAdults] = useState(1);
  const [kids, setKids] = useState(0);
  const [infants, setInfants] = useState(0);
  const [cabinClass, setCabinClass] = useState("ECONOMY");
  const [preffered, setPreferred] = useState("REGULAR");
  const [isDirect, setIsDirect] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);
  const [errors, setErrors] = useState({});
  const [isDomestic, setIsDomestic] = useState("DOMESTIC");
  const [journeyType, setJourneyType] = useState("ONEWAY");
  const inputDRef = useRef(null);
  const inputARef = useRef(null);

  // Custom input component for date picker (same as in your other components)
  const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="input-group">
      <input
        type="text"
        className="form-control"
        value={value}
        onClick={onClick}
        ref={ref}
        readOnly
        placeholder="Select date"
      />
      <button className="btn btn-secondary" type="button" onClick={onClick}>
        <RiCalendarLine />
      </button>
    </div>
  ));

  const validate = () => {
    let temp = {};
    temp.from = from === "" ? false : true;
    temp.to = to === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleDepartureAirportSearch = (e) => {
    const value = e.target.value;
    setDisplayFrom(value);
    if (value.length > 0) {
      const lowerValue = value.toLowerCase();
      const filteredAirports = airports
        .filter(
          (airport) =>
            airport.display === true &&
            airport.airportCode.toLowerCase().includes(value.toLowerCase())
        )
        .slice(0, 10);
      setDepartureResults(filteredAirports);
      if (filteredAirports.length === 0) {
        const filteredAirports1 = airports
          .filter(
            (airport) =>
              airport.airportCode.toLowerCase().includes(lowerValue) ||
              airport.cityName.toLowerCase().includes(lowerValue) ||
              (airport.airportName.toLowerCase().includes(lowerValue) &&
                (!selectedArrival ||
                  airport.airportCode !== selectedArrival.airportCode)) // Exclude selected arrival
          )
          .slice(0, 10);
        setDepartureResults(filteredAirports1);
      }
    } else {
      setDepartureResults([]);
    }
  };
  const handleDepartureAirportClick = (e) => {
    setArrivalResults([]);
    let filteredAirports = airports
      .filter(function (p) {
        return p.display === true;
      })
      .slice(0, 10);
    setDepartureResults(filteredAirports);
    inputDRef.current.select();
  };
  const handleDepartureSelect = (data) => {
    if (selectedArrival && selectedArrival.airportCode === data.airportCode) {
      alert("Departure and arrival airports cannot be the same.");
      setSelectedArrival(null);
      setDisplayTo(""); // Clear arrival input
      return;
    } else {
      var DF =
        data.cityName + "(" + data.airportCode + "), " + data.countryName;
      if (data.countryCode !== "IN") {
        setIsDomestic("INTERNATIONAL");
      }
      setDisplayFrom(DF);
      setLocationFrom(data.airportCode);
      setCityFrom(data.cityName);
      setFrom(data.cityName);
      setSelectedDeparture(data);
      setDepartureResults([]);
    }
  };
  const handleArrivalAirportSearch = (e) => {
    const value = e.target.value;
    setDisplayTo(value);
    if (value.length > 0) {
      const lowerValue = value.toLowerCase();
      const filteredAirports = airports
        .filter(
          (airport) =>
            airport.airportCode.toLowerCase().includes(lowerValue) ||
            airport.cityName.toLowerCase().includes(lowerValue) ||
            airport.airportName.toLowerCase().includes(lowerValue)
        )
        .slice(0, 10);
      setArrivalResults(filteredAirports);
      if (filteredAirports.length === 0) {
        const filteredAirports1 = airports
          .filter((airport) =>
            airport.cityName.toLowerCase().includes(value.toLowerCase())
          )
          .slice(0, 10);
        setArrivalResults(filteredAirports1);
      }
    } else {
      setArrivalResults([]);
    }
  };
  const handleArrivalSelect = (data) => {
    if (
      selectedDeparture &&
      selectedDeparture.airportCode === data.airportCode
    ) {
      alert("Arrival and departure airports cannot be the same.");
      setSelectedDeparture(null);
      setDisplayFrom(""); // Clear departure input
      return;
    } else {
      var DF =
        data.cityName + "(" + data.airportCode + "), " + data.countryName;
      if (data.countryCode !== "IN") {
        setIsDomestic("INTERNATIONAL");
      }
      setDisplayTo(DF);
      setLocationTo(data.airportCode);
      setCityTo(data.cityName);
      setTo(data.cityName);
      setSelectedArrival(data);
      setArrivalResults([]);
    }
  };
  const handleArrivalAirportClick = (e) => {
    setDepartureResults([]);
    let filteredAirports = airports
      .filter(function (p) {
        return p.display === true;
      })
      .slice(0, 10);
    setArrivalResults(filteredAirports);
    inputARef.current.select();
  };
  const handleClassType = (e) => {
    setCabinClass(e.target.value);
  };
  const handleDirectType = (e) => {
    setIsDirect(e.target.checked);
  };
  const handleConnectingType = (e) => {
    setIsConnecting(e.target.checked);
  };
  const handlePrefferedType = (e) => {
    setPreferred(e.target.value);
  };
  const handleIncreaseAdults = (e) => {
    e.stopPropagation();
    setAdults(parseFloat(adults + 1));
  };
  const handleDecreaseAdults = (e) => {
    e.stopPropagation();
    if (adults !== 1) {
      setAdults(parseFloat(adults - 1));
    }
  };
  const handleIncreaseKids = (e) => {
    e.stopPropagation();
    setKids(parseFloat(kids + 1));
  };
  const handleDecreaseKids = (e) => {
    e.stopPropagation();
    if (kids !== 0) {
      setKids(parseFloat(kids - 1));
    }
  };
  const handleIncreaseInfants = (e) => {
    e.stopPropagation();
    setInfants(parseFloat(infants + 1));
  };
  const handleDecreaseInfants = (e) => {
    e.stopPropagation();
    if (infants !== 0) {
      setInfants(parseFloat(infants - 1));
    }
  };
  const handleDepartureDate = (date) => {
    const selectedDate = date;
    setDepartureDate(selectedDate);

    // If returnDate is before the new departureDate, reset it to departureDate
    if (returnDate && selectedDate && returnDate < selectedDate) {
      setReturnDate(selectedDate);
    }
  };
  const handleReturnDate = (date) => {
    setReturnDate(date);
  };
  const handleJourneyType = (e, type) => {
    e.preventDefault();
    setJourneyType(type);
  };
  function GetFlightDestinations() {
    const fvalues = [];
    for (var i = 0; i < trips.length; i++) {
      fvalues.push({
        from: locationFrom,
        to: locationTo,
        departureDate: moment(departureDate).format("YYYY-MM-DD"),
        returnDate: moment(returnDate).format("YYYY-MM-DD"),
      });
    }
    return fvalues;
  }
  const handleSearch = (e) => {
    e.preventDefault();
    console.log(user);
    if (validate()) {
      const searchQuery = {
        journeyType: journeyType,
        isDomestic: isDomestic,
        adults: adults,
        kids: kids,
        infants: infants,
        cabinClass: cabinClass,
        companyId: user?.isSupplierAPI === true ? user.cid : user.parentCompanyId,
        preferred: preffered,
        isDirectFlight: isDirect,
        isConnectingFlight: isConnecting,
        flightTravelerPoints: GetFlightDestinations(),
      };
      navigate(
        "/flights/" + adults + "/" + kids + "/" + infants + "/" + isDomestic,
        { state: { searchQuery } }
      );
    }
  };
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <div className="card-body">
      <div className="row">
        <div className="col-4">
          <ul
            class="nav nav-pills arrow-navtabs nav-success mb-3"
            role="tablist"
          >
            <li class="nav-item me-2" role="presentation">
              <Link
                class={
                  journeyType === "ONEWAY"
                    ? "nav-link active"
                    : "nav-link bg-light"
                }
                name="ONEWAY"
                value={journeyType}
                onClick={(e) => handleJourneyType(e, "ONEWAY")}
                data-bs-toggle="tab"
                href="#arrow-overview"
                role="tab"
                aria-selected="true"
              >
                <span class="d-block d-sm-none">
                  <i class="mdi mdi-home-variant"></i>
                </span>
                <span class="d-none d-sm-block">ONEWAY</span>
              </Link>
            </li>
            <li class="nav-item me-2" role="presentation">
              <Link
                class={
                  journeyType === "RETURN"
                    ? "nav-link active"
                    : "nav-link bg-light"
                }
                name="RETURN"
                value={journeyType}
                onClick={(e) => handleJourneyType(e, "RETURN")}
                data-bs-toggle="tab"
                href="#arrow-profile"
                role="tab"
                aria-selected="false"
                tabindex="-1"
              >
                <span class="d-block d-sm-none">
                  <i class="mdi mdi-account"></i>
                </span>
                <span class="d-none d-sm-block">ROUNDTRIP</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-2">
          <label htmlFor="iconInput" className="form-label">
            FROM
          </label>
          <div className="form-icon position-relative">
            <input
              ref={inputDRef}
              className="form-control form-control-icon"
              type="text"
              placeholder="Search for an airport"
              value={displayFrom}
              onChange={handleDepartureAirportSearch}
              onClick={handleDepartureAirportClick}
              onFocus={handleDepartureAirportClick}
            />
            <RiFlightTakeoffLine className="position-absolute top-50 end-0 translate-middle-y me-2" />
          </div>
          {errors.displayFrom === false ? (
            <div className="validationerror">Please select departure </div>
          ) : (
            ""
          )}
          {departureResults.length > 0 && (
            <ul
              className="locationListVideo scrollable-list"
              style={{ minWidth: "350px" }}
            >
              {departureResults.map((airport) => (
                <li
                  className="locationListVideoItem"
                  key={airport.airportCode}
                  onClick={() => handleDepartureSelect(airport)}
                >
                  <div className="item-name">
                    {airport.cityName} ({airport.airportCode})
                  </div>
                  <div className="item-details">
                    <span className="item-code-date">
                      {airport.airportName},{" "}
                    </span>
                    <span className="item-designation">
                      {airport.countryName}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="col-2">
          <label htmlFor="iconInput" className="form-label">
            TO
          </label>
          <div className="form-icon position-relative">
            <input
              ref={inputARef}
              className="form-control searchTextbox"
              type="text"
              placeholder="Search for an airport"
              value={displayTo}
              onChange={handleArrivalAirportSearch}
              onClick={handleArrivalAirportClick}
              onFocus={handleArrivalAirportClick}
            />
            <RiFlightLandLine className="position-absolute top-50 end-0 translate-middle-y me-2" />
          </div>
          {arrivalResults.length > 0 && (
            <ul
              className="locationListVideo scrollable-list"
              style={{ minWidth: "350px" }}
            >
              {arrivalResults.map((airport) => (
                <li
                  className="locationListVideoItem"
                  key={airport.airportCode}
                  onClick={() => handleArrivalSelect(airport)}
                >
                  <div className="item-name">
                    {airport.cityName} ({airport.airportCode})
                  </div>
                  <div className="item-details">
                    <span className="item-code-date">
                      {airport.airportName}
                    </span>
                    <span className="item-designation">
                      {airport.countryName}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="col-2">
          <label htmlFor="iconInput" className="form-label">
            DEPARTURE DATE
          </label>
          <DatePicker
            selected={departureDate}
            onChange={handleDepartureDate}
            customInput={<CustomDateInput />}
            dateFormat="dd-MMM-yyyy"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            minDate={new Date()}
            yearDropdownItemNumber={50}
            scrollableYearDropdown
            className="form-control"
            placeholder="DEPARTURE DATE"
          />
        </div>
        {journeyType === "RETURN" ? (
          <div className="col-2">
            <label htmlFor="iconInput" className="form-label">
              RETURN DATE
            </label>
            <DatePicker
              selected={returnDate}
              onChange={handleReturnDate}
              customInput={<CustomDateInput />}
              dateFormat="dd-MMM-yyyy"
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              minDate={departureDate}
              yearDropdownItemNumber={50}
              scrollableYearDropdown
              className="form-control"
              placeholder="RETURN DATE"
            />
          </div>
        ) : (
          ""
        )}
        <div className="col-3">
          <label htmlFor="iconInput" className="form-label">
            TRAVELLERS & CLASS
          </label>
          <div class="dropdown" data-bs-auto-close="outside">
            <div
              class=" form-control w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {adults +
                " Adults, " +
                kids +
                " Kids, " +
                infants +
                " Infants & " +
                cabinClass}
            </div>
            <div
              className="dropdown-menu p-3"
              aria-labelledby="dropdownMenuButton"
            >
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <span>Adults</span>
                <div className="input-step d-flex align-items-center">
                  <button
                    type="button"
                    className="minus"
                    onClick={handleDecreaseAdults}
                  >
                    –
                  </button>
                  <input
                    type="number"
                    className="product-quantity text-center"
                    min="1"
                    max="9"
                    readOnly
                    value={adults}
                    name="adults"
                  />
                  <button
                    type="button"
                    className="plus"
                    onClick={handleIncreaseAdults}
                  >
                    +
                  </button>
                </div>
              </div>
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <span>Kids</span>
                <div className="input-step d-flex align-items-center">
                  <button
                    type="button"
                    className="minus"
                    onClick={handleDecreaseKids}
                  >
                    –
                  </button>
                  <input
                    type="number"
                    className="product-quantity text-center"
                    min="0"
                    max="9"
                    readOnly
                    value={kids}
                    name="kids"
                  />
                  <button
                    type="button"
                    className="plus"
                    onClick={handleIncreaseKids}
                  >
                    +
                  </button>
                </div>
              </div>
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <span>Infants</span>
                <div className="input-step d-flex align-items-center">
                  <button
                    type="button"
                    className="minus"
                    onClick={handleDecreaseInfants}
                  >
                    –
                  </button>
                  <input
                    type="number"
                    className="product-quantity text-center"
                    min="0"
                    max="5"
                    readOnly
                    value={infants}
                    name="infants"
                  />
                  <button
                    type="button"
                    className="plus"
                    onClick={handleIncreaseInfants}
                  >
                    +
                  </button>
                </div>
              </div>
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="cabinClass"
                    id="ECONOMY"
                    onChange={(e) => handleClassType(e)}
                    value="ECONOMY"
                    checked={cabinClass === "ECONOMY" ? true : false}
                  ></input>
                  <label class="form-check-label" for="inlineRadio1">
                    REGULAR
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="cabinClass"
                    id="BUSINESS"
                    onChange={(e) => handleClassType(e)}
                    value="BUSINESS"
                    checked={cabinClass === "BUSINESS" ? true : false}
                  ></input>
                  <label class="form-check-label" for="inlineRadio2">
                    BUSINESS
                  </label>
                </div>
              </div>
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="cabinClass"
                    id="FIRST"
                    onChange={(e) => handleClassType(e)}
                    value="ECONOMY"
                    checked={cabinClass === "FIRST" ? true : false}
                  ></input>
                  <label class="form-check-label" for="inlineRadio2">
                    FIRST
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="cabinClass"
                    id="PREMIUM_ECONOMY"
                    onChange={(e) => handleClassType(e)}
                    value="PREMIUM_ECONOMY"
                    checked={cabinClass === "PREMIUM_ECONOMY" ? true : false}
                  ></input>
                  <label class="form-check-label" for="inlineRadio2">
                    PREMIUM ECONOMY
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-1">
          <button
            type="button"
            onClick={handleSearch}
            className="w-100 btn btn-danger mt-4"
          >
            SEARCH
          </button>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-10 mt-2">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="preffered"
              id="REGULAR"
              onChange={(e) => handlePrefferedType(e)}
              value="REGULAR"
              checked={preffered === "REGULAR" ? true : false}
            ></input>
            <label class="form-check-label" for="REGULAR">
              REGULAR
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="preffered"
              id="STUDENT"
              onChange={(e) => handlePrefferedType(e)}
              value="STUDENT"
              checked={preffered === "STUDENT" ? true : false}
            ></input>
            <label class="form-check-label" for="STUDENT">
              STUDENT
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="preffered"
              id="CORPORATE"
              onChange={(e) => handlePrefferedType(e)}
              value="CORPORATE"
              checked={preffered === "CORPORATE" ? true : false}
            ></input>
            <label class="form-check-label" for="CORPORATE">
              CORPORATE
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              name="isDirect"
              id="isDirect"
              onChange={(e) => handleDirectType(e)}
              value={isDirect}
              checked={isDirect}
            ></input>
            <label class="form-check-label" for="isDirect">
              DIRECT FLIGHT?
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              name="isConnecting"
              id="isConnecting"
              onChange={(e) => handleConnectingType(e)}
              value={isConnecting}
              checked={isConnecting}
            ></input>
            <label class="form-check-label" for="isConnecting">
              CONNECTING FLIGHT?
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFlightPanel;
